<template>
  <div class="event" :class="{ open: open }">
    <div class="score-board-table">
      <div class="score-board-table-head">
        <div class="comment">
          <span class="kind-name" v-if="event.kind">{{ event.kind }}</span>
          {{ event.results.minute ? event.results.minute : '' }}
          <span class="time-blink" v-if="event.results.minute">'</span>
          {{ event.results.comment }}
        </div>
        <div class="right-flex" v-if="event.results.score" style="margin-right: 10px;">
          <div class="common-score score-cell">{{ $t('live.score') }}</div>
          <div class="flex" v-if="event.results.score.periods">
            <div class="score-cell" v-for="(p, i) in event.results.score.periods" :key="i">{{ i + 1 }}</div>
          </div>
          <div class="score-cell" v-if="event.results.score.yellowCards" :title="$t('live.yellow-cards')">
            <sport-icon medium name="yellow-card" />
          </div>
          <div class="score-cell" v-if="event.results.score.corners" :title="$t('live.corners')">
            <sport-icon medium name="corner" />
          </div>
        </div>
      </div>
      <div class="score-board-table-team">
        <div class="team-name">{{ event.home }}</div>
        <div class="right-flex" v-if="event.results.score" style="margin-right: 10px;">
          <div class="common-score score-cell">{{ event.results.score.home }}</div>
          <div class="flex" v-if="event.results.score.periods">
            <div class="score-cell" v-for="(p, i) in event.results.score.periods" :key="i">{{ p.home }}</div>
          </div>
          <div class="score-cell" v-if="event.results.score.yellowCards">{{ event.results.score.yellowCards.home }}</div>
          <div class="score-cell" v-if="event.results.score.corners">{{ event.results.score.corners.home }}</div>
          <div class="game-score score-cell" v-if="event.results.points">{{ event.results.points.home }}</div>
          <div class="turn-cell" v-if="event.results.turn && event.results.turn === 1">
            <sport-icon medium :name="sport.alias" />
          </div>
        </div>
      </div>
      <div class="score-board-table-team">
        <div class="team-name">{{ event.away }}</div>
        <div class="right-flex" v-if="event.results.score" style="margin-right: 10px;">
          <div class="common-score score-cell">{{ event.results.score.away }}</div>
          <div class="flex" v-if="event.results.score.periods">
            <div class="score-cell" v-for="(p, i) in event.results.score.periods" :key="i">{{ p.away }}</div>
          </div>
          <div class="score-cell" v-if="event.results.score.yellowCards">{{ event.results.score.yellowCards.away }}</div>
          <div class="score-cell" v-if="event.results.score.corners">{{ event.results.score.corners.away }}</div>
          <div class="game-score score-cell" v-if="event.results.points">{{ event.results.points.away }}</div>
          <div class="turn-cell" v-if="event.results.turn && event.results.turn === 2">
            <sport-icon medium :name="sport.alias" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconButton from '@/components/buttons/IconButton'
import ArrowIcon from '@/components/icons/ArrowIcon'
import SportIcon from '@/components/icons/SportIcon'

export default {
  components: {
    IconButton,
    ArrowIcon,
    SportIcon
  },
  props: {
    sport: Object,
    league: Object,
    event: Object
  },
  data () {
    return {
      open: false
    }
  }
}
</script>

<style scoped>
.event { overflow: hidden; position: relative; }
.event-hat { align-items: center; display: flex; min-height: 40px; }
.event-time { flex-shrink: 0; text-align: center; width: 80px; }
.event-name { flex: 1; }
.event-result { width: 40%; }
.event-extra { /* border-top: 1px solid #007354; */ display: none; margin-left: 10px; padding: 10px 10px 10px 0; }
.event-extra p:not(:first-child) { margin-top: 5px; }
.event-extra b { color: #007354; font-weight: normal; }
.open.event .event-extra { display: block; }
.white { color: white !important; }

.match-layout { margin: 0 10px; background: white; }
.score-board-table { position: relative; margin-top: 5px; margin-bottom: 5px; }
.score-board-table-head { /* border-bottom: 1px solid rgba(255, 255, 255, .07); */ display: flex; height: 24px; line-height: 24px; margin-bottom: 4px; }
.score-board-table-head .comment { color: #713592; margin-left: 10px; }
.score-board-table-head .kind-name { color: #342d6e; margin-right: 5px; }
.score-board-table-team { display: flex; height: 23px; font-size: 14px; line-height: 23px; margin-left: 10px; }
.score-cell { text-align: center; width: 34px; color: darkorange; font-weight: normal; }
.common-score { color: darkorange; margin-left: 10px; font-weight: 600; }
.common-score.score-cell { color: darkorange; font-weight: 600;}
.game-score { color: darkorange; margin-right: 7px; }
.turn-cell { width: 16px; }
.pause { width: 100%; text-align: center; height: 50px; line-height: 50px; font-size: 14pt; }
</style>



// WEBPACK FOOTER //
// src/components/results/live/list/Event.vue